import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage4.module.css";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/transpersonalEgg.json";

export default function LaymanPage4() {
  return (
    <>
      <Common_html BlockData={BlockData} />
    </>
  );
}
